import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default storage (localStorage)
import { combineReducers } from "redux"; // Import combineReducers
import convoReducer from "../Reducers/convoReducer";
import dexyReducer from "../Reducers/dexyReducer";

// Configuration for redux-persist ....
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["convo", "dexy"], // Specify which reducers to persist
};

// Combine reducers
const rootReducer = combineReducers({
  convo: convoReducer,
  dexy: dexyReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Optionally ignore specific actions during serialization check
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"], // If needed, adjust actions
      },
    }),
});

// Create a persistor object
export const persistor = persistStore(store);
export default store;
